import { Badge, Box, Typography } from "@mui/material";
import React from "react";
import theme from "../../utils/theme";

interface Props {
  index: number;
  url: string;
  categoryName: string;
}

const CategoryCard: React.FC<Props> = ({ index, url, categoryName }) => {
  return (
    <Box key={index} sx={{ px: { xs: 5, md: 8, lg: 12 }, mx: 'auto' , width: "100%" }}>
        <Box
            sx={{
            backgroundImage: `url("${url}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: 60,
            width: 60,
            borderRadius: "50%",
            position: "relative"
        }}
        >
            <Badge
              badgeContent={index}
              color="primary"
              sx={{ position: "absolute", top: 10, left: 0 }}
            />
            <Box
              sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  left: 55,
                  bottom: -50,
                  width: 200,
                  height: 60,
                  position: "absolute",
                  backgroundColor: theme.palette.primary.main,
                  borderTopRightRadius: "20px",
                  borderBottomLeftRadius: "20px",
              }}
              >
              <Typography
                  sx={{ textAlign: "center", color: "#fff", fontSize: "14px" }}
              >
                  {categoryName}
              </Typography>
            </Box>
        </Box>
    </Box>
  );
};

export default CategoryCard;
